import { render } from "./MainInformation.vue?vue&type=template&id=7bbf26c7&scoped=true"
const script = {}

import "./MainInformation.vue?vue&type=style&index=0&id=7bbf26c7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.27_vue@3.5.27_typescript@5.3.3__webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bbf26c7"]])

export default __exports__